<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardContent
        :cardContent="content"
        :cardTypeProps="cardTypeProps"
        @nextRoute="nextRoute"
        :soundOBJ="soundObject"
      />
    </template>
  </div>
</template>
<script>
import CardContent from '../../../components/template/Chinese1/CardContent';
import CardPopupImg from '../../../components/template/Chinese1/CardPopupImg';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardContent, CardPopupImg, LoadingMDL},
  name: 'CTA05',
  data() {
    return {
      cardTypeProps: true,
      content: {},
      lang: this.$store.getters['language/getLanguage'],
      baseURL: 'CTA05-',
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      soundObject: [],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseSection: '',
      startTime: '',
      condition: [],
      courseId: '',
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }
      var data = this.content.content.page[0].paragraph;

      for (let i = 0; i < data.length; i++) {
        this.soundObject.push(new Audio(this.baseUrl + data[i].line[0].class));
      }

      this.loading = false;
    },

    storeLanguage: function (val) {
      this.lang = val;
    },
    '$route.params.id'() {
      this.onLoadData();
    },
  },

  mounted() {
    this.onLoadData();
  },

  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse'].code;
    this.courseId = this.$store.state.necessary.learningCourse;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    onLoadData() {
      const contentId = `CTA05-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(path) {
      if (path.type == 0) {
        this.goBack(path.path);
      } else if (path.type == 1) {
        this.linkNextTo(path.path);
      }
    },
    linkNextTo(path) {
      let str = path.split('-');
      //data form
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch
      this.$store.dispatch('v3/saveContent', data);

      this.$router.push(`/v3/${str[0]}/${str[1]}`);
    },
    goBack(path) {
      let str = path.split('-');
      this.$router.push(`/v3/${str[0]}/${str[1]}`);
    },
  },
};
</script>
<style></style>
